var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c(
      "div",
      { staticClass: "page-titles border-bottom" },
      [
        _c("h3", [
          _vm._v("Limited Partners\n        "),
          _vm.investors
            ? _c("span", { staticClass: "card-subtitle" }, [
                _vm._v(
                  _vm._s(
                    _vm.trans("general.total_result_found", {
                      count: _vm.investors.total,
                    })
                  )
                ),
              ])
            : _c("span", { staticClass: "card-subtitle" }, [
                _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
              ]),
        ]),
        _vm._v(" "),
        _c("sort-by", {
          staticClass: "pull-right",
          attrs: {
            "order-by-options": _vm.orderByOptions,
            "sort-by": _vm.filterInvestorForm.sort_by,
            order: _vm.filterInvestorForm.order,
          },
          on: {
            updateSortBy: (value) => {
              _vm.filterInvestorForm.sort_by = value
            },
            updateOrder: (value) => {
              _vm.filterInvestorForm.order = value
            },
          },
        }),
        _vm._v(" "),
        !_vm.showFilterPanel
          ? _c(
              "button",
              {
                staticClass: "btn btn-info btn-sm pull-right m-r-10",
                on: {
                  click: function ($event) {
                    _vm.showFilterPanel = !_vm.showFilterPanel
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-filter" }),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-sm-inline" }, [
                  _vm._v(_vm._s(_vm.trans("general.filter"))),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.showCreatePanel && _vm.hasPermission("create-user")
          ? _c(
              "button",
              {
                staticClass: "btn btn-info btn-sm pull-right m-r-10",
                on: {
                  click: function ($event) {
                    _vm.showCreatePanel = !_vm.showCreatePanel
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-plus" }),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-sm-inline" }, [
                  _vm._v(_vm._s(_vm.trans("investor.create_investor"))),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-20",
        staticStyle: { "font-size": "0.625em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showFilterPanel
                  ? _c("div", { staticClass: "card border-bottom" }, [
                      _c("div", { staticClass: "card-body p-4" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.trans("general.filter"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "hq_country" } }, [
                                _vm._v("Label"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterInvestorForm.label,
                                      expression: "filterInvestorForm.label",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { name: "active" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterInvestorForm,
                                        "label",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("All"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "none" } }, [
                                    _vm._v("None"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.labels, function (label, index) {
                                    return _c("option", { key: label.name }, [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(label.name) +
                                          "\n                        "
                                      ),
                                    ])
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(_vm._s(_vm.trans("investor.name"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterInvestorForm.name,
                                    expression: "filterInvestorForm.name",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "name", name: "name" },
                                domProps: {
                                  value: _vm.filterInvestorForm.name,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterInvestorForm,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "contact_person" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.trans("investor.contact_person"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.filterInvestorForm.contact_person,
                                    expression:
                                      "filterInvestorForm.contact_person",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "contact_person",
                                  name: "contact_person",
                                },
                                domProps: {
                                  value: _vm.filterInvestorForm.contact_person,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterInvestorForm,
                                      "contact_person",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "preferred_geography" } },
                                  [_vm._v("Preferred Geography")]
                                ),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: "name",
                                    "track-by": "name",
                                    name: "preferred_geography",
                                    id: "preferred_geography",
                                    options: _vm.countries,
                                    placeholder: "Please choose",
                                    multiple: true,
                                    "close-on-select": true,
                                    "clear-on-select": false,
                                    "hide-selected": true,
                                    placeholder: "Please choose",
                                    selectLabel: "choose",
                                    selected:
                                      _vm.selected_preferred_geographies,
                                  },
                                  on: {
                                    select: _vm.onPreferredGeographySelect,
                                    remove: _vm.onPreferredGeographyRemove,
                                  },
                                  model: {
                                    value: _vm.selected_preferred_geographies,
                                    callback: function ($$v) {
                                      _vm.selected_preferred_geographies = $$v
                                    },
                                    expression:
                                      "selected_preferred_geographies",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "preferred_fund_type_organization",
                                    },
                                  },
                                  [_vm._v("Preferred Fund Type")]
                                ),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: "name",
                                    "track-by": "name",
                                    name: "preferred_fund_type_organization",
                                    id: "preferred_fund_type_organization",
                                    options: _vm.investor_preferred_fund_types,
                                    placeholder: "Please choose",
                                    multiple: true,
                                    "close-on-select": true,
                                    "clear-on-select": false,
                                    "hide-selected": true,
                                    placeholder: "Please choose",
                                    selectLabel: "choose",
                                    selected:
                                      _vm.selected_preferred_fund_type_organizations,
                                  },
                                  on: {
                                    select:
                                      _vm.onInvestorPreferredFundTypeSelect,
                                    remove:
                                      _vm.onInvestorPreferredFundTypeRemove,
                                  },
                                  model: {
                                    value:
                                      _vm.selected_preferred_fund_type_organizations,
                                    callback: function ($$v) {
                                      _vm.selected_preferred_fund_type_organizations =
                                        $$v
                                    },
                                    expression:
                                      "selected_preferred_fund_type_organizations",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "preferred_fund_type_organization",
                                    },
                                  },
                                  [_vm._v("Limited Partner Type")]
                                ),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: "name",
                                    "track-by": "name",
                                    name: "limited_partner_type_organization",
                                    id: "limited_partner_type_organization",
                                    options:
                                      _vm.limited_partner_type_organizations,
                                    placeholder: "Please choose",
                                    multiple: true,
                                    "close-on-select": true,
                                    "clear-on-select": false,
                                    "hide-selected": true,
                                    placeholder: "Please choose",
                                    selectLabel: "choose",
                                    selected:
                                      _vm.selected_limited_partner_type_organizations,
                                  },
                                  on: {
                                    select:
                                      _vm.onLimitedPartnerTypeOrganizationSelect,
                                    remove:
                                      _vm.onLimitedPartnerTypeOrganizationRemove,
                                  },
                                  model: {
                                    value:
                                      _vm.selected_limited_partner_type_organizations,
                                    callback: function ($$v) {
                                      _vm.selected_limited_partner_type_organizations =
                                        $$v
                                    },
                                    expression:
                                      "selected_limited_partner_type_organizations",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "investment_structure" } },
                                  [_vm._v("Investment Structure")]
                                ),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: "name",
                                    "track-by": "name",
                                    name: "investment_structure",
                                    id: "investment_structure",
                                    options: _vm.investment_structures,
                                    placeholder: "Please choose",
                                    multiple: true,
                                    "close-on-select": true,
                                    "clear-on-select": false,
                                    "hide-selected": true,
                                    placeholder: "Please choose",
                                    selectLabel: "choose",
                                    selected:
                                      _vm.selected_investment_structures,
                                  },
                                  on: {
                                    select: _vm.onInvestmentStructureSelect,
                                    remove: _vm.onInvestmentStructureRemove,
                                  },
                                  model: {
                                    value: _vm.selected_investment_structures,
                                    callback: function ($$v) {
                                      _vm.selected_investment_structures = $$v
                                    },
                                    expression:
                                      "selected_investment_structures",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "hq_country" } }, [
                                  _vm._v("HQ Country"),
                                ]),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: "name",
                                    "track-by": "name",
                                    name: "hq_country",
                                    id: "hq_country",
                                    options: _vm.countries,
                                    placeholder: "Please choose",
                                    multiple: true,
                                    "close-on-select": true,
                                    "clear-on-select": false,
                                    "hide-selected": true,
                                    placeholder: "Please choose",
                                    selectLabel: "choose",
                                    selected: _vm.selected_hq_countries,
                                  },
                                  on: {
                                    select: _vm.onHQCountrySelect,
                                    remove: _vm.onHQCountryRemove,
                                  },
                                  model: {
                                    value: _vm.selected_hq_countries,
                                    callback: function ($$v) {
                                      _vm.selected_hq_countries = $$v
                                    },
                                    expression: "selected_hq_countries",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "hq_country" } }, [
                                  _vm._v("HQ Global Sub Region"),
                                ]),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: "name",
                                    "track-by": "name",
                                    name: "hq_global_sub_region",
                                    id: "hq_global_sub_region",
                                    options: _vm.regions,
                                    placeholder: "Please choose",
                                    multiple: true,
                                    "close-on-select": true,
                                    "clear-on-select": false,
                                    "hide-selected": true,
                                    placeholder: "Please choose",
                                    selectLabel: "choose",
                                    selected:
                                      _vm.selected_hq_global_sub_regions,
                                  },
                                  on: {
                                    select: _vm.onHQGlobalSubRegionSelect,
                                    remove: _vm.onHQGlobalSubRegionRemove,
                                  },
                                  model: {
                                    value: _vm.selected_hq_global_sub_regions,
                                    callback: function ($$v) {
                                      _vm.selected_hq_global_sub_regions = $$v
                                    },
                                    expression:
                                      "selected_hq_global_sub_regions",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "hq_country" } }, [
                                  _vm._v("HQ Global Region"),
                                ]),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: "name",
                                    "track-by": "name",
                                    name: "hq_global_region",
                                    id: "hq_global_region",
                                    options: _vm.continents,
                                    placeholder: "Please choose",
                                    multiple: true,
                                    "close-on-select": true,
                                    "clear-on-select": false,
                                    "hide-selected": true,
                                    placeholder: "Please choose",
                                    selectLabel: "choose",
                                    selected: _vm.selected_hq_global_regions,
                                  },
                                  on: {
                                    select: _vm.onHQGlobalRegionSelect,
                                    remove: _vm.onHQGlobalRegionRemove,
                                  },
                                  model: {
                                    value: _vm.selected_hq_global_regions,
                                    callback: function ($$v) {
                                      _vm.selected_hq_global_regions = $$v
                                    },
                                    expression: "selected_hq_global_regions",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.showFilterPanel
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-sm pull-right",
                                on: {
                                  click: function ($event) {
                                    _vm.showFilterPanel = !_vm.showFilterPanel
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "btn btn-info btn-sm",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.getExportLink.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Export")]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.hasPermission("create-user")
                ? _c("transition", { attrs: { name: "fade" } }, [
                    _vm.showCreatePanel
                      ? _c("div", { staticClass: "card border-bottom" }, [
                          _c("div", { staticClass: "card-body p-4" }, [
                            _c(
                              "form",
                              {
                                attrs: { autocomplete: "off" },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submit.apply(null, arguments)
                                  },
                                  keydown: function ($event) {
                                    return _vm.newInvestorForm.errors.clear(
                                      $event.target.name
                                    )
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-12" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "investor.name"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.newInvestorForm
                                                          .name,
                                                      expression:
                                                        "newInvestorForm.name",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    value: "",
                                                    name: "name",
                                                    placeholder:
                                                      _vm.trans(
                                                        "investor.name"
                                                      ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.newInvestorForm.name,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.newInvestorForm,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name":
                                                      _vm.newInvestorForm,
                                                    "prop-name": "name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-info waves-effect waves-light pull-right",
                                    attrs: { type: "submit" },
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.add")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-danger waves-effect waves-light pull-right m-r-10",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showCreatePanel =
                                          !_vm.showCreatePanel
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.investors.total
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.hasPermission("list-user") && _vm.investors.total
                          ? _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                { staticClass: "table table-hover" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Label"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("investor.name"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("investor.contact_person")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "table-option",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.action"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.investors.data,
                                      function (investor) {
                                        return _c("tr", [
                                          _c("td", {
                                            staticStyle: {
                                              "font-size": "12px",
                                              width: "100px",
                                            },
                                            domProps: {
                                              textContent: _vm._s(
                                                investor.label
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("td", {
                                            domProps: {
                                              textContent: _vm._s(
                                                investor.name
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("td", {
                                            domProps: {
                                              textContent: _vm._s(
                                                investor.contact_person
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "table-option" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "btn-group" },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName: "v-tooltip",
                                                          value: _vm.trans(
                                                            "investor.view_investor"
                                                          ),
                                                          expression:
                                                            "trans('investor.view_investor')",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "btn btn-info btn-sm",
                                                      attrs: {
                                                        to: `/account/investors/${investor.id}`,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-circle-right",
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.hasPermission(
                                                    "delete-user"
                                                  )
                                                    ? _c(
                                                        "button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "confirm",
                                                              rawName:
                                                                "v-confirm",
                                                              value: {
                                                                ok: _vm.confirmDelete(
                                                                  investor
                                                                ),
                                                                message:
                                                                  "Do you really want to delete the investor?",
                                                                okText:
                                                                  "Delete",
                                                                cancelText:
                                                                  "Cancel",
                                                              },
                                                              expression:
                                                                "{ok: confirmDelete(investor), message: 'Do you really want to delete the investor?', okText: 'Delete', cancelText: 'Cancel'}",
                                                            },
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value: _vm.trans(
                                                                "investor.delete_investor"
                                                              ),
                                                              expression:
                                                                "trans('investor.delete_investor')",
                                                            },
                                                          ],
                                                          key: investor.id,
                                                          staticClass:
                                                            "btn btn-danger btn-sm",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-trash",
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination-record", {
                          attrs: {
                            "page-length": _vm.filterInvestorForm.page_length,
                            records: _vm.investors,
                          },
                          on: {
                            "update:pageLength": function ($event) {
                              return _vm.$set(
                                _vm.filterInvestorForm,
                                "page_length",
                                $event
                              )
                            },
                            "update:page-length": function ($event) {
                              return _vm.$set(
                                _vm.filterInvestorForm,
                                "page_length",
                                $event
                              )
                            },
                            updateRecords: _vm.getInvestors,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }